import { useEffect, useRef } from "react";

export type UseAddRefOptions = {
  addRef: (ref: HTMLDivElement) => void;
  index?: number;
};

const useAddRef = ({ addRef }: UseAddRefOptions) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!!ref?.current) {
      addRef?.(ref.current);
    }
  }, [ref?.current]);

  return ref;
};

export default useAddRef;
